var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.13872 9.15709C7.13872 8.85221 7.18849 8.57843 7.28805 8.33576C7.38761 8.09309 7.59294 7.88154 7.90405 7.70109C7.99738 7.64509 8.11249 7.57976 8.24938 7.50509C8.38627 7.43043 8.52005 7.34332 8.65072 7.24376C8.78138 7.14421 8.89027 7.02909 8.97738 6.89843C9.07072 6.76776 9.11738 6.61532 9.11738 6.44109C9.11738 6.18598 9.02716 5.98998 8.84672 5.85309C8.66627 5.70998 8.46094 5.63843 8.23072 5.63843C7.95694 5.63843 7.72983 5.72243 7.54938 5.89043C7.36894 6.0522 7.22894 6.21709 7.12938 6.38509L6.31738 5.82509C6.47916 5.44554 6.73738 5.14998 7.09205 4.93843C7.45294 4.72687 7.84494 4.62109 8.26805 4.62109C8.58538 4.62109 8.89027 4.68643 9.18272 4.81709C9.48138 4.94154 9.72716 5.14065 9.92005 5.41443C10.1129 5.68198 10.2094 6.03043 10.2094 6.45976C10.2094 6.85798 10.1192 7.17532 9.93872 7.41176C9.75827 7.64198 9.52183 7.84732 9.22938 8.02776C9.06138 8.12732 8.89649 8.22376 8.73472 8.31709C8.57294 8.41043 8.43605 8.52243 8.32405 8.65309C8.21827 8.77754 8.16538 8.94554 8.16538 9.15709H7.13872ZM7.15738 11.3318V10.0438H8.19338V11.3318H7.15738Z",
    fill: "#A4A6AD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 5.6,
    stroke: "#A4A6AD",
    strokeWidth: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.f0dd288c.svg";
export { ForwardRef as ReactComponent };